// PROJECT DISCONTINUE

import React, { Component } from 'react';

import ic_cancel from '../resources/cancel_circle.png';
import ic_delete from '../resources/baseline_delete.png';
import ic_search from '../resources/baseline_search.png';
import Dropdown from '../native/Dropdown';
import ProductSearchDialog from './ProductSearchDialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

var request = require('../../utilities/NetworkRequest');
var cache_util = require('../../utilities/CacheUtil');

function formatDateForInput(dateStr) {
  if (!dateStr) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return dateStr;
  }
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [d, m, y] = dateStr.split('-');
    return `${y}-${m}-${d}`;
  }
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
    const [d, m, y] = dateStr.split('/');
    return `${y}-${m}-${d}`;
  }
  const d = new Date(dateStr);
  if (!isNaN(d.getTime())) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }
  return '';
}

export default class BundleProductCreateDialog extends Component {

  constructor(props) {
    super(props);
    const initial_data = JSON.parse(this.props.data);
    const isLocked = initial_data.is_wholesaler_locked === true;
    const ownWholesaler = initial_data.wholesaler_id || '';

    this.state = {
      is_loading: false,
      show_product_search: false,
      product_search_index: -1,
      is_wholesaler_locked: isLocked,
      available_wholesalers: [],
      bundle_data: {
        bundle_name: '',
        is_limited: false,
        is_active: true,
        is_all_wholesaler: !isLocked,
        is_set_price: false,
        wholesaler_id: ownWholesaler,
        c_data: 0,
        max_claim_per_so: 1,
        image: null,
        imgtiny_url: null,
        start_date: formatDateForInput(initial_data.start_date || ''),
        end_date: formatDateForInput(initial_data.end_date || '')
      },
      status_bundle: {
        selected: {
          key: true,
          label: 'Aktif'
        },
        is_expand: false,
        data: [
          { key: true, label: 'Aktif' },
          { key: false, label: 'Non-Aktif' }
        ]
      },
      kondisi_bundle: {
        selected: { key: false, label: 'Tidak Ter-Batas' },
        is_expand: false,
        data: [
          { key: true, label: 'Ter-Batas' },
          { key: false, label: 'Tidak Ter-Batas' }
        ]
      },
      set_harga_bundle: {
        selected: { key: false, label: 'TIDAK' },
        is_expand: false,
        data: [
          { key: true, label: 'YA' },
          { key: false, label: 'TIDAK' }
        ]
      },
      semua_grosir_bundle: {
        selected: { key: !isLocked, label: !isLocked ? 'YA' : 'TIDAK' },
        is_expand: false,
        data: [
          { key: true, label: 'YA' },
          { key: false, label: 'TIDAK' }
        ]
      },
      bundle_details: [],
      // Auto-fill with own wholesaler if locked
      detail_wholesaler: isLocked && ownWholesaler ? [{ wholesaler_id: ownWholesaler, wholesaler_name: '' }] : [],
      error_message: ''
    }
  }

  componentDidMount() {
    request.onRequestData(request.OPTION_API_MAIN, '/list/wholesaler', { view_id: 'list_wholesaler' }, (res_data) => {
      if (res_data.code === 1) {
        const list = (res_data.result || []).filter(r => r.is_active === true && r.status_go === 'LIVE');
        this.setState({ available_wholesalers: list }, () => {
          if (this.state.is_wholesaler_locked && this.state.detail_wholesaler.length > 0) {
            const currentWsId = this.state.detail_wholesaler[0].wholesaler_id;
            const match = list.find(w => w.wholesaler_id === currentWsId);
            if (match) {
              const detail_wholesaler = [{ wholesaler_id: match.wholesaler_id, wholesaler_name: match.wholesaler_name }];
              this.setState({ detail_wholesaler });
            }
          }
        });
      }
    });
  }

  formatCurrency(amount) {
    if (amount === null || amount === undefined) return '';
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(amount);
  }

  parseCurrency(str) {
    if (!str) return 0;
    return parseInt(str.replace(/[^\d]/g, ''), 10) || 0;
  }

  onBundleNameChange(e) {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.bundle_name = e.target.value;
    this.setState({ bundle_data });
  }

  onCDataChange(e) {
    const value = e.target.value;
    const bundle_data = { ...this.state.bundle_data };
    // Allow empty string so the field can be cleared (e.g. deleting the "0")
    bundle_data.c_data = value === '' ? '' : (parseInt(value, 10) || 0);
    this.setState({ bundle_data });
  }

  onStatusChange(selected) {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.is_active = selected.key;
    this.setState({
      bundle_data,
      status_bundle: { ...this.state.status_bundle, selected }
    });
  }

  onKondisiChange(selected) {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.is_limited = selected.key;
    this.setState({
      bundle_data,
      kondisi_bundle: { ...this.state.kondisi_bundle, selected }
    });
  }

  onSetHargaChange(selected) {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.is_set_price = selected.key;
    this.setState({
      bundle_data,
      set_harga_bundle: { ...this.state.set_harga_bundle, selected }
    });
  }

  onSemuaGrosirChange(selected) {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.is_all_wholesaler = selected.key;
    this.setState({
      bundle_data,
      semua_grosir_bundle: { ...this.state.semua_grosir_bundle, selected }
    });
  }

  onImageSelected(event) {
    const file = event.target.files[0];
    if (file) {
      const bundle_data = { ...this.state.bundle_data };
      bundle_data.image = file;
      bundle_data.imgtiny_url = URL.createObjectURL(file);
      this.setState({ bundle_data });
    }
  }

  onRemoveImage() {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.image = null;
    bundle_data.imgtiny_url = null;
    this.setState({ bundle_data });
  }

  onUseProductImage(imageUrl) {
    const bundle_data = { ...this.state.bundle_data };
    bundle_data.image = null; // No file upload, just URL reference
    bundle_data.imgtiny_url = imageUrl;
    this.setState({ bundle_data });
  }

  onProductIdChange(index, value) {
    const bundle_details = [...this.state.bundle_details];
    bundle_details[index] = { ...bundle_details[index], product_id: value };
    this.setState({ bundle_details });
  }

  onProductNameChange(index, value) {
    const bundle_details = [...this.state.bundle_details];
    bundle_details[index] = { ...bundle_details[index], product_name: value };
    this.setState({ bundle_details });
  }

  onProductQuantityChange(index, value) {
    const bundle_details = [...this.state.bundle_details];
    if (value === '') {
      bundle_details[index] = { ...bundle_details[index], quantity: '' };
    } else {
      let qty = parseInt(value, 10) || 0;
      if (qty > 999) qty = 999;
      bundle_details[index] = { ...bundle_details[index], quantity: qty };
    }
    this.setState({ bundle_details });
  }

  onUnitChange(index, value) {
    const bundle_details = [...this.state.bundle_details];
    bundle_details[index] = { ...bundle_details[index], unit: value };
    this.setState({ bundle_details });
  }

  onProductPriceChange(index, value) {
    const bundle_details = [...this.state.bundle_details];
    bundle_details[index] = { ...bundle_details[index], price: this.parseCurrency(value) };
    this.setState({ bundle_details });
  }

  onDeleteProduct(index) {
    const bundle_details = [...this.state.bundle_details];
    bundle_details.splice(index, 1);
    this.setState({ bundle_details });
  }

  onSearchProduct(index) {
    // Validasi: kalau Semua Grosir = TIDAK, Daftar Grosir harus terisi minimal 1 kode grosir
    if (!this.state.bundle_data.is_all_wholesaler) {
      const hasValidWholesaler = this.state.detail_wholesaler.some(
        w => w.wholesaler_id && String(w.wholesaler_id).trim() !== ''
      );
      if (!hasValidWholesaler) {
        this.setState({
          error_message: 'Pilih "Semua Grosir = TIDAK" mengharuskan mengisi Daftar Grosir minimal 1 kode grosir sebelum menambah produk.'
        });
        return;
      }
    }
    this.setState({
      show_product_search: true,
      product_search_index: index,
      error_message: ''
    });
  }

  onProductSearchClose(action, product) {
    // Save index before resetting state
    const selectedIndex = this.state.product_search_index;
    this.setState({
      show_product_search: false,
      product_search_index: -1
    }, () => {
      if (action === 'select' && product) {
        const bundle_details = [...this.state.bundle_details];

        // Get price from API (sellingPrice is the main price field from backend)
        const productPrice = product.sellingPrice || product.price || 0;
        // Get image URL from imgtiny_url or img_url
        const productImageUrl = product.imgtiny_url || product.img_url || null;

        // Check if the target row is empty - if so, just fill it
        const isEmptyRow = selectedIndex >= bundle_details.length ||
          !bundle_details[selectedIndex] ||
          (bundle_details[selectedIndex].product_id === '' &&
           bundle_details[selectedIndex].product_name === '');

        if (isEmptyRow) {
          // Ensure array is long enough
          while (bundle_details.length <= selectedIndex) {
            bundle_details.push({
              product_id: '',
              product_name: '',
              quantity: 1,
              unit: '',
              price: 0,
              original_price: 0,
              image_url: null
            });
          }
          // Fill the row with selected product
          bundle_details[selectedIndex] = {
            product_id: product.pcode || product.product_id || '',
            product_name: product.pcode_name || product.name || '',
            unit: product.uom_b_mst || product.uom_b || product.uom || product.uom_a || '',
            quantity: 1,
            price: productPrice,
            original_price: productPrice,
            image_url: productImageUrl
          };
        } else {
          // Row has data, create new row with selected product
          bundle_details.push({
            product_id: product.pcode || product.product_id || '',
            product_name: product.pcode_name || product.name || '',
            unit: product.uom_b_mst || product.uom_b || product.uom || product.uom_a || '',
            quantity: 1,
            price: productPrice,
            original_price: productPrice,
            image_url: productImageUrl
          });
        }

        this.setState({ bundle_details });
      }
    });
  }

  onDeleteWholesaler(index) {
    const detail_wholesaler = [...this.state.detail_wholesaler];
    detail_wholesaler.splice(index, 1);
    this.setState({ detail_wholesaler });
  }

  onAddWholesaler() {
    const detail_wholesaler = [...this.state.detail_wholesaler];
    detail_wholesaler.push({
      wholesaler_id: '',
      wholesaler_name: ''
    });
    this.setState({ detail_wholesaler });
  }

  onWholesalerSelect(index, selected) {
    const detail_wholesaler = [...this.state.detail_wholesaler];
    if (selected) {
      detail_wholesaler[index] = {
        wholesaler_id: selected.wholesaler_id,
        wholesaler_name: selected.wholesaler_name
      };
    } else {
      detail_wholesaler[index] = {
        wholesaler_id: '',
        wholesaler_name: ''
      };
    }
    this.setState({ detail_wholesaler });
  }

  onWholesalerIdChange(index, value) {
    const detail_wholesaler = [...this.state.detail_wholesaler];
    detail_wholesaler[index] = { ...detail_wholesaler[index], wholesaler_id: value };
    this.setState({ detail_wholesaler });
  }

  onWholesalerNameChange(index, value) {
    const detail_wholesaler = [...this.state.detail_wholesaler];
    detail_wholesaler[index] = { ...detail_wholesaler[index], wholesaler_name: value };
    this.setState({ detail_wholesaler });
  }

  onSave() {
    if (!this.state.bundle_data.bundle_name || this.state.bundle_data.bundle_name.trim() === '') {
      this.setState({ error_message: 'Nama Bundle tidak boleh kosong' });
      return;
    }

    if (this.state.bundle_details.length === 0) {
      this.setState({ error_message: 'Detail Produk tidak boleh kosong' });
      return;
    }

    this.setState({ is_loading: true, error_message: '' }, () => {
      // Format bundle_details for API
      const bundleDetailsFormatted = this.state.bundle_details.map((item, index) => ({
        product_id: item.product_id,
        uom: item.unit,
        quantity: parseInt(item.quantity, 10) || 1,
        price: item.price || 0,
        group_product: index + 1
      }));

      // Format detail_wholesaler for API
      const detailWholesalerFormatted = this.state.detail_wholesaler
        .filter(ws => ws.wholesaler_id && ws.wholesaler_id.trim() !== '')
        .map(ws => ({
          wholesaler_id: ws.wholesaler_id
        }));

      // Use FormData for multipart upload
      const formData = new FormData();
      formData.append('bundle_name', this.state.bundle_data.bundle_name);
      formData.append('is_active', this.state.bundle_data.is_active ? 'true' : 'false');
      formData.append('is_all_wholesaler', this.state.bundle_data.is_all_wholesaler ? 'true' : 'false');
      formData.append('is_limited', this.state.bundle_data.is_limited ? 'true' : 'false');
      formData.append('is_set_price', this.state.bundle_data.is_set_price ? 'true' : 'false');
      formData.append('c_data', this.state.bundle_details.length);
      formData.append('max_claim_per_so', this.state.bundle_data.max_claim_per_so || 1);
      formData.append('qty_max', this.state.bundle_data.max_claim_per_so || 1);
      formData.append('start_date', this.state.bundle_data.start_date);
      formData.append('end_date', this.state.bundle_data.end_date);
      formData.append('bundle_details', JSON.stringify(bundleDetailsFormatted));
      formData.append('detail_wholesaler', JSON.stringify(detailWholesalerFormatted));
      formData.append('wholesaler_id', this.state.bundle_data.wholesaler_id);
      // user_id dari session login (selalu tersedia di user_information, lihat Dashboard.js:288)
      const user_info_create = cache_util.onGetCacheData(cache_util.CACHE_INFO).result.user_information;
      formData.append('user_id', user_info_create.user_id || '');

      // Append image if selected
      if (this.state.bundle_data.image) {
        formData.append('image', this.state.bundle_data.image);
      }

      request.onRequestForm(1, '/post/promo_bundle', formData, (res_data) => {
        if (res_data.code === 1) {
          this.props.onCloseListener('next', this.state.bundle_data);
        } else {
          this.setState({
            is_loading: false,
            error_message: res_data.message || 'Terjadi kesalahan'
          });
        }
      });
    });
  }

  render() {
    const { bundle_data, status_bundle, kondisi_bundle, set_harga_bundle, semua_grosir_bundle, bundle_details, detail_wholesaler, is_loading, error_message, is_wholesaler_locked } = this.state;
    const canEditPrice = bundle_data.is_set_price;
    const showWholesalerList = !bundle_data.is_all_wholesaler && !is_wholesaler_locked;

    return (
      <div onClick={(e) => this.props.onCloseListener('close', null)} className='process_dialog_root layer_a'>
        <div onClick={(e) => e.stopPropagation()} className='process_dialog_container' style={{ width: 950, maxHeight: 650 }}>
          {/* Header */}
          <div className='title_search_container green_background'>
            <div className='full_flex default_text_medium_white bold_text'>TAMBAH PROMO BUNDLE</div>
            <img onClick={(e) => this.props.onCloseListener('close', null)} className='custom_cursor_a mini_image_c' src={ic_cancel} alt='' />
          </div>

          {/* Error Message */}
          {error_message && (
            <div style={{ padding: '10px 15px', backgroundColor: '#fee', color: '#c00', margin: '10px 15px', borderRadius: 4 }}>
              {error_message}
            </div>
          )}

          {/* Loading */}
          {is_loading && (
            <div style={{ padding: 20, textAlign: 'center' }}>
              <span className='default_text_normal_gray'>Menyimpan data...</span>
            </div>
          )}

          <div style={{ padding: 15, overflow: 'auto', maxHeight: 550 }}>
            {/* Bundle Info Section */}
            <div style={{ marginBottom: 20 }}>
              <div className='default_text_normal_gray bold_text' style={{ marginBottom: 10, fontSize: 14 }}>Informasi Promo Bundle</div>

              <div style={{ display: 'flex', gap: 20 }}>
                {/* Left Side - Info Fields (Vertical Stack) */}
                <div style={{ flex: 1 }}>
                  {/* Row 1 - Nama Bundle */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Nama Bundle</span></div>
                    <div style={{ flex: 1 }}>
                      <input
                        onChange={(e) => this.onBundleNameChange(e)}
                        value={bundle_data.bundle_name}
                        style={{ width: '100%', padding: '6px 10px' }}
                        className='default_text_normal_gray non_transparent_input'
                        type='text'
                        placeholder='Masukkan nama bundle'
                      />
                    </div>
                  </div>
                  {/* Row 2 - Kondisi */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Kondisi</span></div>
                    <div style={{ flex: 1 }}>
                      <Dropdown data={kondisi_bundle} listener_change={(selected) => this.onKondisiChange(selected)} />
                    </div>
                  </div>
                  {/* Row 3 - Status */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Status</span></div>
                    <div style={{ flex: 1 }}>
                      <Dropdown data={status_bundle} listener_change={(selected) => this.onStatusChange(selected)} />
                    </div>
                  </div>
                  {/* Row 4 - Semua Grosir - hidden if locked */}
                  {!is_wholesaler_locked && (
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                      <div style={{ width: 140 }}><span className='default_text_normal_gray'>Semua Grosir</span></div>
                      <div style={{ flex: 1 }}>
                        <Dropdown data={semua_grosir_bundle} listener_change={(selected) => this.onSemuaGrosirChange(selected)} />
                      </div>
                    </div>
                  )}
                  {/* Row 5 - Set Harga */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Set Harga</span></div>
                    <div style={{ flex: 1 }}>
                      <Dropdown data={set_harga_bundle} listener_change={(selected) => this.onSetHargaChange(selected)} />
                    </div>
                  </div>
                  {/* Row 6 - Tanggal Mulai */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Tanggal Mulai</span></div>
                    <div style={{ flex: 1 }}>
                      <input
                        type='date'
                        value={bundle_data.start_date}
                        onChange={(e) => {
                          const bundle_data = { ...this.state.bundle_data };
                          bundle_data.start_date = e.target.value;
                          this.setState({ bundle_data });
                        }}
                        style={{ width: '100%', padding: '6px 10px' }}
                        className='default_text_normal_gray non_transparent_input'
                      />
                    </div>
                  </div>
                  {/* Row 7 - Tanggal Berakhir */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Tanggal Berakhir</span></div>
                    <div style={{ flex: 1 }}>
                      <input
                        type='date'
                        value={bundle_data.end_date}
                        onChange={(e) => {
                          const bundle_data = { ...this.state.bundle_data };
                          bundle_data.end_date = e.target.value;
                          this.setState({ bundle_data });
                        }}
                        style={{ width: '100%', padding: '6px 10px' }}
                        className='default_text_normal_gray non_transparent_input'
                      />
                    </div>
                  </div>
                  {/* Row 8 - Jumlah SKU (Di bawah tanggal berakhir, disabled, otomatis dari daftar produk) */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}><span className='default_text_normal_gray'>Jumlah SKU</span></div>
                    <div style={{ flex: 1 }}>
                      <input
                        type='number'
                        disabled
                        value={bundle_details.length}
                        style={{ width: '100%', padding: '6px 10px', backgroundColor: '#f0f0f0', cursor: 'not-allowed', color: '#555' }}
                        className='default_text_normal_gray non_transparent_input'
                        title='Jumlah SKU otomatis dihitung dari daftar produk di bawah'
                      />
                    </div>
                  </div>
                  {/* Row 9 - Maks. Klaim per Pesanan (SO) */}
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ width: 140 }}>
                      <span className='default_text_normal_gray'>Maks. Klaim per Pesanan</span>
                    </div>
                    <div style={{ flex: 1 }}>
                      <input
                        type='number'
                        min='1'
                        value={bundle_data.max_claim_per_so !== undefined ? bundle_data.max_claim_per_so : 1}
                        onChange={(e) => {
                          const val = e.target.value;
                          const bundle_data = { ...this.state.bundle_data };
                          bundle_data.max_claim_per_so = val === '' ? '' : Math.max(1, parseInt(val, 10) || 1);
                          this.setState({ bundle_data });
                        }}
                        style={{ width: '100%', padding: '6px 10px' }}
                        className='default_text_normal_gray non_transparent_input'
                        placeholder='Contoh: 1'
                        title='Batas maksimal klaim promo bundle dalam satu pesanan (SO)'
                      />
                    </div>
                  </div>
                </div>

                {/* Right Side - Image */}
                <div style={{ width: 150 }}>
                  <div className='default_text_normal_gray' style={{ marginBottom: 5, fontSize: 12 }}>Gambar Bundle</div>
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    {bundle_data.imgtiny_url ? (
                      <div style={{ position: 'relative' }}>
                        <img
                          src={bundle_data.imgtiny_url}
                          alt='Bundle'
                          style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 4, border: '1px solid #ddd' }}
                        />
                        <div
                          onClick={() => this.onRemoveImage()}
                          style={{ position: 'absolute', top: -8, right: -8, width: 24, height: 24, backgroundColor: '#c00', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                        >
                          <img src={ic_delete} alt='Remove' style={{ width: 14, height: 14, filter: 'brightness(0) invert(1)' }} />
                        </div>
                      </div>
                    ) : (
                      <div style={{ width: 120, height: 120, backgroundColor: '#f5f5f5', borderRadius: 4, border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span className='default_text_normal_gray' style={{ fontSize: 12 }}>No Image</span>
                      </div>
                    )}
                  </div>
                  <div>
                    <input
                      accept='image/x-png,image/jpeg'
                      onChange={(event) => this.onImageSelected(event)}
                      type='file'
                      id='bundle_image_create'
                      style={{ display: 'none' }}
                    />
                    <label
                      htmlFor='bundle_image_create'
                      style={{ display: 'inline-block', padding: '8px 16px', backgroundColor: '#2196F3', color: '#fff', borderRadius: 4, cursor: 'pointer', fontSize: 13 }}
                    >
                      Upload Gambar
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Daftar Grosir Section - Only show if is_all_wholesaler = false */}
            {showWholesalerList && (
              <div style={{ marginBottom: 20 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                  <div className='default_text_normal_gray bold_text' style={{ fontSize: 14 }}>
                    Daftar Grosir
                    {is_wholesaler_locked && (
                      <span style={{ fontWeight: 'normal', color: '#666', fontSize: 11, marginLeft: 8 }}>
                        (Terkunci - hanya grosir Anda)
                      </span>
                    )}
                  </div>
                  {!is_wholesaler_locked && (
                    <div
                      onClick={() => this.onAddWholesaler()}
                      style={{ padding: '6px 12px', backgroundColor: '#4CAF50', color: '#fff', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}
                    >
                      + Tambah Grosir
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', backgroundColor: '#f0f0f0', padding: '10px 5px', fontWeight: 'bold', borderBottom: '1px solid #ccc', alignItems: 'center' }}>
                  <div style={{ flex: 0.5, textAlign: 'center' }}>No</div>
                  <div style={{ flex: 2 }}>Pilih Grosir</div>
                  <div style={{ flex: 1 }}>Kode Grosir</div>
                  <div style={{ flex: 1.5 }}>Nama Grosir</div>
                  {!is_wholesaler_locked && <div style={{ flex: 0.5, textAlign: 'center' }}>Action</div>}
                </div>
                {detail_wholesaler && detail_wholesaler.length > 0 ? (
                  detail_wholesaler.map((ws, index) => (
                    <div key={index} style={{ display: 'flex', padding: '8px 5px', borderBottom: '1px solid #eee', alignItems: 'center' }}>
                      <div style={{ flex: 0.5, textAlign: 'center' }} className='default_text_normal_gray'>{index + 1}</div>
                      <div style={{ flex: 2, padding: '0 4px' }}>
                        {is_wholesaler_locked ? (
                          <span className='default_text_normal_gray'>{ws.wholesaler_name || ws.wholesaler_id}</span>
                        ) : (
                          <Autocomplete
                            size='small'
                            options={this.state.available_wholesalers || []}
                            getOptionLabel={(opt) => opt ? `${opt.wholesaler_id} - ${opt.wholesaler_name}` : ''}
                            value={(this.state.available_wholesalers || []).find(w => w.wholesaler_id === ws.wholesaler_id) || (ws.wholesaler_id ? { wholesaler_id: ws.wholesaler_id, wholesaler_name: ws.wholesaler_name || '' } : null)}
                            onChange={(e, val) => this.onWholesalerSelect(index, val)}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder='Cari & pilih grosir...'
                                variant='outlined'
                                size='small'
                              />
                            )}
                          />
                        )}
                      </div>
                      <div style={{ flex: 1, padding: '0 4px' }}>
                        <input
                          type='text'
                          value={ws.wholesaler_id || ''}
                          disabled
                          style={{ width: '100%', padding: '6px 8px', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                          className='default_text_normal_gray non_transparent_input'
                          placeholder='Kode'
                        />
                      </div>
                      <div style={{ flex: 1.5, padding: '0 4px' }}>
                        <input
                          type='text'
                          value={ws.wholesaler_name || ''}
                          disabled
                          style={{ width: '100%', padding: '6px 8px', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                          className='default_text_normal_gray non_transparent_input'
                          placeholder='Nama Grosir'
                        />
                      </div>
                      {!is_wholesaler_locked && (
                        <div style={{ flex: 0.5, textAlign: 'center' }}>
                          <img
                            onClick={() => this.onDeleteWholesaler(index)}
                            className='mini_image_d custom_cursor_a'
                            src={ic_delete}
                            alt='Delete'
                            title='Hapus'
                            style={{ filter: 'brightness(0)', opacity: 0.8, cursor: 'pointer' }}
                          />
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div style={{ padding: 15, textAlign: 'center', color: is_wholesaler_locked ? '#999' : '#c00' }}>
                    {is_wholesaler_locked
                      ? 'Tidak ada grosir'
                      : '⚠ Wajib menambahkan minimal 1 grosir sebelum menambah produk. Klik "+ Tambah Grosir" untuk memilih grosir.'}
                  </div>
                )}
              </div>
            )}

            {/* Product Details Section */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <div className='default_text_normal_gray bold_text' style={{ fontSize: 14 }}>
                  Daftar Produk
                  {canEditPrice && <span style={{ fontWeight: 'normal', color: '#666', fontSize: 12 }}> - Harga dapat diedit</span>}
                </div>
                <div
                  onClick={() => this.onSearchProduct(this.state.bundle_details.length)}
                  style={{ padding: '6px 12px', backgroundColor: '#4CAF50', color: '#fff', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}
                >
                  + Tambah Produk
                </div>
              </div>

              {/* Table */}
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f0f0f0' }}>
                    <th style={{ padding: '8px 4px', textAlign: 'center', width: 40 }}>No</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', width: 50 }}>Img</th>
                    <th style={{ padding: '8px 4px', textAlign: 'left', width: 100 }}>Product ID</th>
                    <th style={{ padding: '8px 4px', textAlign: 'left' }}>Nama Produk</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', width: 50 }}>Qty</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', width: 60 }}>Unit</th>
                    <th style={{ padding: '8px 4px', textAlign: 'right', width: 100 }}>Harga Asli / satuan</th>
                    <th style={{ padding: '8px 4px', textAlign: 'right', width: 100 }}>Harga Set / satuan</th>
                    <th style={{ padding: '8px 4px', textAlign: 'right', width: 100 }}>Total Harga</th>
                    <th style={{ padding: '8px 4px', textAlign: 'center', width: 40 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {bundle_details && bundle_details.length > 0 ? (
                    bundle_details.map((item, index) => {
                      const unitPrice = canEditPrice
                        ? (item.price || 0)
                        : (item.price !== undefined && item.price !== null ? item.price : (item.original_price || 0));
                      const rowTotal = (parseInt(item.quantity, 10) || 0) * unitPrice;
                      return (
                        <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: '6px 4px', textAlign: 'center' }}>{index + 1}</td>
                          <td style={{ padding: '6px 4px', textAlign: 'center' }}>
                            {item.image_url ? (
                              <img
                                src={item.image_url}
                                alt={item.product_name}
                                style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 4, border: '1px solid #eee', cursor: 'pointer' }}
                                onClick={() => item.image_url && this.onUseProductImage(item.image_url)}
                                title={bundle_data.imgtiny_url !== item.image_url ? 'Klik untuk jadi gambar bundle' : ''}
                              />
                            ) : (
                              <div
                                onClick={() => this.onSearchProduct(index)}
                                style={{ width: 32, height: 32, backgroundColor: '#f5f5f5', borderRadius: 4, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}
                              >
                                <img src={ic_search} alt='' style={{ width: 16, height: 16, opacity: 0.5 }} />
                              </div>
                            )}
                          </td>
                          <td style={{ padding: '4px' }}>
                            <input
                              type='text'
                              value={item.product_id || ''}
                              onChange={(e) => this.onProductIdChange(index, e.target.value)}
                              style={{ width: '100%', padding: '4px 6px' }}
                              className='default_text_normal_gray non_transparent_input'
                            />
                          </td>
                          <td style={{ padding: '4px' }}>
                            <input
                              type='text'
                              value={item.product_name || ''}
                              onChange={(e) => this.onProductNameChange(index, e.target.value)}
                              style={{ width: '100%', padding: '4px 6px' }}
                              className='default_text_normal_gray non_transparent_input'
                            />
                          </td>
                          <td style={{ padding: '4px', textAlign: 'center' }}>
                            <input
                              type='number'
                              min='1'
                              max='999'
                              value={item.quantity || ''}
                              onChange={(e) => this.onProductQuantityChange(index, e.target.value)}
                              style={{ width: '100%', padding: '4px 6px', textAlign: 'center' }}
                              className='default_text_normal_gray non_transparent_input'
                            />
                          </td>
                          <td style={{ padding: '4px', textAlign: 'center' }}>
                            <input
                              type='text'
                              disabled
                              value={item.unit || ''}
                              style={{ width: '100%', padding: '4px 6px', textAlign: 'center', backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                              className='default_text_normal_gray non_transparent_input'
                            />
                          </td>
                          <td style={{ padding: '4px', textAlign: 'right', color: '#888', fontSize: 12 }}>
                            {item.original_price ? this.formatCurrency(item.original_price) : (item.price ? this.formatCurrency(item.price) : '-')}
                          </td>
                          <td style={{ padding: '4px', textAlign: 'right' }}>
                            {canEditPrice ? (
                              <input
                                type='text'
                                value={item.price ? this.formatCurrency(item.price).replace('Rp', '').trim() : ''}
                                onChange={(e) => this.onProductPriceChange(index, e.target.value)}
                                style={{ width: '100%', padding: '4px 6px', textAlign: 'right' }}
                                className='default_text_normal_gray non_transparent_input'
                                placeholder='0'
                              />
                            ) : (
                              <span>{item.price ? this.formatCurrency(item.price) : '-'}</span>
                            )}
                          </td>
                          <td style={{ padding: '4px', textAlign: 'right' }}>
                            <input
                              type='text'
                              disabled
                              value={this.formatCurrency(rowTotal)}
                              style={{ width: '100%', padding: '4px 6px', textAlign: 'right', backgroundColor: '#f5f5f5', cursor: 'not-allowed', color: '#333' }}
                              className='default_text_normal_gray non_transparent_input'
                            />
                          </td>
                          <td style={{ padding: '4px', textAlign: 'center' }}>
                            <img
                              onClick={() => this.onDeleteProduct(index)}
                              className='mini_image_d custom_cursor_a'
                              src={ic_delete}
                              alt='Delete'
                              title='Hapus'
                              style={{ filter: 'brightness(0)', opacity: 0.8, cursor: 'pointer' }}
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan='10' style={{ padding: 20, textAlign: 'center', color: '#999' }}>
                        Klik "+ Tambah Produk" untuk menambahkan produk
                      </td>
                    </tr>
                  )}
                </tbody>
                {bundle_details && bundle_details.length > 0 && (
                  <tfoot>
                    <tr style={{ backgroundColor: '#f9f9f9', borderTop: '2px solid #ddd', fontWeight: 'bold' }}>
                      <td colSpan='8' style={{ padding: '8px 10px', textAlign: 'right' }}>Total:</td>
                      <td style={{ padding: '8px 4px', textAlign: 'right', color: '#2e7d32', fontWeight: 'bold' }}>
                        {this.formatCurrency(bundle_details.reduce((sum, itm) => {
                          const uPrice = canEditPrice
                            ? (itm.price || 0)
                            : (itm.price !== undefined && itm.price !== null ? itm.price : (itm.original_price || 0));
                          return sum + ((parseInt(itm.quantity, 10) || 0) * uPrice);
                        }, 0))}
                      </td>
                      <td></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>

          {/* Product Search Dialog */}
          {this.state.show_product_search && (
            <ProductSearchDialog
              wholesaler_id={bundle_data.wholesaler_id}
              wholesaler_ids={this.state.detail_wholesaler
                .map(w => w.wholesaler_id)
                .filter(id => id && String(id).trim() !== '')}
              onCloseListener={(action, product) => this.onProductSearchClose(action, product)}
            />
          )}

          {/* Footer Buttons */}
          <div style={{ padding: '10px 15px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <div
              onClick={() => this.props.onCloseListener('close', null)}
              style={{ padding: '8px 20px', cursor: 'pointer', backgroundColor: '#e0e0e0', borderRadius: 4 }}
              className='default_text_normal_gray'
            >
              Batal
            </div>
            <div
              onClick={() => this.onSave()}
              style={{ padding: '8px 20px', cursor: 'pointer', backgroundColor: '#4CAF50', borderRadius: 4 }}
              className='default_text_normal_white'
            >
              Simpan
            </div>
          </div>
        </div>
      </div>
    );
  }

}